import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { lng } from '../../i18n/cfg.json';
import discordNoLogo from "../../assets/img/discordNoLogo.png";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container
} from "reactstrap";

import { settingsSetLang } from '../../redux/actions/settings.action';
const AdminNavbar = (props) => {
  const { t } = useTranslation(['common']);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [color, setColor] = React.useState("navbar-transparent");
  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const getAvailableLang = () => {
    var temp = [...lng];
    const index = temp.findIndex(lang => lang === props.locale);
    temp.splice(index, 1);
    return temp;
  }
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setColor("navbar-transparent");
    } else {
      setColor("bg-white");
    }
    setCollapseOpen(!collapseOpen);
  };
  return (
    <>
      <Navbar
        className={classNames("navbar", {
          [color]: props.location.pathname.indexOf("full-screen-map") === -1,
        })}
        expand="lg"
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize d-inline">
              <Button
                className="minimize-sidebar btn-just-icon"
                color="link"
                id="tooltip209599"
                onClick={props.handleMiniClick}
              >
                <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
              </Button>
            </div>
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <button
                className="navbar-toggler"
                type="button"
                onClick={props.toggleSidebar}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand onClick={(e) => e.preventDefault()}>
              {props.brandText}
            </NavbarBrand>
          </div>

          <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 1 } }}>
            <Collapse navbar isOpen={collapseOpen}>
              <Nav className="ml-auto" navbar>
                <div className="languageSelect">
                  <UncontrolledDropdown nav className="languageDropdown">
                    <DropdownToggle
                          caret
                          color="default"
                          data-toggle="dropdown"
                          nav
                          onClick={(e) => e.preventDefault()}
                    >
                      <img alt="flag" src={require(`assets/img/flags/flag-${props.locale}.svg`).default} height="30px" width="30px"/>

                    </DropdownToggle>
                      <DropdownMenu className="dropdown-navbar" right tag="ul" >
                        {getAvailableLang().map(i => {
                          return(<DropdownItem key={i} className="nav-item"><img alt="flag" src={require(`assets/img/flags/flag-${i}.svg`).default} className="flagImg" onClick={() => props.settingsSetLang(i)} /></DropdownItem>)
                        })}
                      </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                {props.pseudo && <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                    onClick={(e) => e.preventDefault()}
                  >
                    <div className="photo">
                      <img
                        alt="..."
                        src={props.avatar ? `https://cdn.discordapp.com/avatars/${props.avatar}.png?size=128` : discordNoLogo}
                      />
                    </div>
                    <b className="caret d-none d-lg-block d-xl-block" />
                    <p className="d-lg-none">{t('logout')}</p>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                    <NavLink tag="li">
                      <DropdownItem tag={Link} to="/profile" className="nav-item">{t('profile')}</DropdownItem>
                    </NavLink>
                    <DropdownItem divider tag="li" />
                    <NavLink tag="li">
                      <DropdownItem className="nav-item" onClick={()=> window.open("/logout", "_self")}>{t('logout')}</DropdownItem>
                    </NavLink>
                  </DropdownMenu>
                </UncontrolledDropdown>}
                <li className="separator d-lg-none" />
              </Nav>
            </Collapse>
          </motion.div>
        </Container>
      </Navbar>
    </>
  );
};

const mapStateToProps = (state) => {
  const { pseudo, avatar } = state.infos;
  const { locale } = state.settings;
  return { pseudo, locale, avatar };
};

const mapDispatchToProps = {
  settingsSetLang
};

//export default AdminNavbar;
export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);